import Repository from '../axios'
import {
  defaultPagination
} from "@/constants/config";
const resource = "/admin/system_setting";

export default {
  getCcp(id) {
    return Repository.get(`${resource}/ccp-items/${id}`)
  },
  getListOfCcp(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/ccp-items?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getListOfCcpNoPagination(filterQuery) {
    return Repository.get(`${resource}/ccp-items?is_paginate=0&${filterQuery}`)
  },
  createCcp(payload) {
    return Repository.post(`${resource}/ccp-items`, payload)
  },
  deleteCcp(id) {
    return Repository.delete(`${resource}/ccp-items/${id}`)
  },
  updateCcp(id, payload) {
    return Repository.put(`${resource}/ccp-items/${id}`, payload)
  },
  //ccp item fields
  getCcpItemFields(id) {
    return Repository.get(`${resource}/ccp-items/${id}/item-fields`)
  },
  updateCcpItemFields(id, payload) {
    return Repository.post(`${resource}/ccp-items/${id}/item-fields`, payload)
  }
};
